import React from 'react';
var DatePicker = require('react-bootstrap-date-picker');
var Api = require('./Config');
import _ from 'lodash';
import ReactPaginate from 'react-paginate';

import { saveAs } from './FileSaver';

export default class AdminFax extends React.Component {
  constructor(props) {
    super(props);
    this.state = { page: 1, data: [], total: 0, pageSize: 25, sort: 'orderkey', direction: 'ASC' };
    this.handlePageClick = this.handlePageClick.bind(this);
  }

  doSort(sortBy) {
    if (this.state.sort == sortBy) {
      this.state.direction = this.state.direction == 'DESC' ? 'ASC' : 'DESC';
    } else {
      this.state.direction = 'ASC';
    }

    this.state.sort = sortBy;
    this.state.page = 1;
    this.state.data = [];
    this.setState({});
    this.getData();
  }

  handlePageClick(data) {
    let selected = data.selected;
    window.scrollTo(0, 0);
    this.state.page = selected + 1;
    this.state.data = [];
    this.setState({});
    this.getData();
  }

  getPages() {
    if (!this.state.total) {
      return;
    }
    var totalRows = this.state.total;
    var totalPages = Math.ceil(totalRows / this.state.pageSize);

    return (
      <div style={{ marginLeft: 10, marginRight: 10, display: 'flex', alignItems: 'center' }}>
        <div style={{ marginRight: 20 }}>
          <select
            value={this.state.pageSize}
            onChange={(e) => {
              this.state.pageSize = e.target.value;
              this.state.page = 1;
              this.setState({ pageSize: e.target.value });

              this.getData();
            }}
            className="form-control"
          >
            <option value="25">Show 25</option>
            <option value="50">Show 50</option>
            <option value="75">Show 75</option>
            <option value="100">Show 100</option>
          </select>
        </div>
        <div>
          <ReactPaginate
            previousLabel={'previous'}
            nextLabel={'next'}
            forcePage={this.state.page - 1}
            breakLabel={<a href="#">...</a>}
            breakClassName={'break-me'}
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={this.handlePageClick}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
          />
        </div>
      </div>
    );
  }

  getData() {
    Api.getFaxLogs(this.state.page, this.state.pageSize, this.state.sort, this.state.direction)
      .then((result) => {
        this.setState({ data: result.data, total: result.total });
        // console.log(data);
      })
      .catch((err) => {
        alert(err);
        console.log(err);
      });
  }

  componentDidMount() {
    this.getData();
  }

  getRow(row, index) {
    return (
      <tr className={row['status'] == 'failed' ? 'text-danger' : ''} style={{ fontSize: 12 }} key={row._id}>
        <td>{index + 1 + (this.state.page - 1) * this.state.pageSize}</td>
        <td>{row['app_code']}</td>
        <td>{row['sent_to']}</td>
        <td>{row['t_code']}</td>
        <td>{Api.getDateFormat(row['sent_date'])}</td>
        <td>{row['status']}</td>
        <td>{Api.getDateFormat(row['last_checked_date'])}</td>
        <td>{row['total_retries']}</td>
        <td>{row['retries']}</td>
        <td>{Api.getDateFormat(row['last_retry_date'])}</td>
        <td>{row['status'] == 'failed' && Api.getDateFormat(row['nextdate'])}</td>
        <td>
          {row['nextdate'] == 'None' && (
            <button
              onClick={() => {
                Api.requeFax(row['id'])
                  .then(() => {
                    this.getData();
                  })
                  .catch((err) => {
                    console.log(err);
                    alert(err);
                  });
              }}
              className="btn btn-sm btn-info"
            >
              Resend
            </button>
          )}
        </td>
        <td>
          <button
            onClick={() => {
              if (confirm('are you sure you want to hide ?')) {
                Api.hideFax(row['id']).then(() => {
                  this.getData();
                });
              }
            }}
            className="fa btn btn-xs fa-trash"
          ></button>
        </td>
      </tr>
    );
  }

  getSortButton(label, sortBy) {
    if (this.state.sort != sortBy) {
      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => {
            this.doSort(sortBy);
          }}
          className="text-primary"
        >
          {label}
          <i className="fa fa-sort"></i>
        </div>
      );
    } else {
      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => {
            this.doSort(sortBy);
          }}
          className=" text-success"
        >
          {label}
          <i className={'fa fa-arrow' + (this.state.direction == 'ASC' ? '-down' : '-up')}></i>
        </div>
      );
    }
  }

  doExportToCSV() {
    Api.doExportFaxesToCSV()
      .then(({ rows }) => {
        const blob = new Blob([rows], { type: 'text/plain;charset=utf-8' });
        saveAs(blob, new Date() + 'fax_export-report.csv');
      })
      .catch((err) => {
        alert(err);
      });
  }

  render() {
    return (
      <div>
        <div>
          <div className="panel panel-info">
            <div
              className="panel-heading"
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            >
              <div>Faxes</div>
              <div>
                <button
                  onClick={() => {
                    this.getData();
                  }}
                  className="btn btn-info"
                >
                  Reload
                </button>
                <button
                  style={{ marginLeft: 10 }}
                  onClick={() => {
                    this.doExportToCSV();
                  }}
                  className="btn btn-primary"
                >
                  Export To CSV
                </button>
              </div>
            </div>
            <div className="panel-body">
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{this.getSortButton('App Code', 'app_code')}</th>
                    <th>Fax</th>
                    <th> {this.getSortButton('T.Code', 't_code')}</th>
                    <th> {this.getSortButton('Sent Date', 'sent_date')}</th>
                    <th>{this.getSortButton('Status', 'orderkey')}</th>
                    <th>Last Status Check</th>
                    <th>
                      Total <br /> Resend <br /> count
                    </th>
                    <th>
                      Resend <br /> Count
                    </th>
                    <th>Last Resend </th>
                    <th>Next Resend </th>
                    <th>...</th>
                    <th>Hide</th>
                  </tr>
                </thead>
                <tbody>{_.map(this.state.data, (a, b) => this.getRow(a, b))}</tbody>
              </table>
            </div>
            <div className="panel-footer">{this.getPages()}</div>
          </div>
        </div>
      </div>
    );
  }
}
